import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const TOWN_COORDS = {
  "cooma": [-36.2350, 149.1250],
  "berridale": [-36.3650, 148.8280],
  "east jindabyne": [-36.3960, 148.6480],
  "jindabyne": [-36.4149, 148.6131],
  "kalkite": [-36.3390, 148.6690],
  "hilltop": [-36.3790, 148.6800],
  "moonbah": [-36.5200, 148.5500],
};

const priceIcon = (price) => L.divIcon({
  className: "",
  html: `<div style="background:#1b4332;color:#fff;border:2px solid #d4a531;border-radius:9999px;padding:2px 8px;font-size:11px;font-weight:700;white-space:nowrap;box-shadow:0 1px 4px rgba(0,0,0,.35)">$${Number(price).toFixed(0)}</div>`,
  iconSize: null, iconAnchor: [16, 12],
});

export default function TownCoverageMap({ towns, coords }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current || !towns || !Object.keys(towns).length) return;
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    const pts = [];
    Object.entries(towns).forEach(([town, price]) => {
      const key = town.toLowerCase();
      const extra = coords?.[key];
      const c = extra && extra.lat != null ? [extra.lat, extra.lng] : TOWN_COORDS[key];
      if (!c) return;
      pts.push(c);
      L.marker(c, { icon: priceIcon(price) }).addTo(map)
        .bindPopup(`<b style="text-transform:capitalize">${town}</b><br/>Fixed delivery $${Number(price).toFixed(2)} inc GST`);
    });
    if (pts.length) map.fitBounds(L.latLngBounds(pts), { padding: [24, 24] });
    return () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [JSON.stringify(towns), JSON.stringify(coords)]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!towns || !Object.keys(towns).length) return null;
  return <div ref={ref} data-testid="town-coverage-map" className="h-64 w-full overflow-hidden rounded-lg border border-border" />;
}
